import { createFeatureSelector, createSelector } from "@ngrx/store";
import { accountReducer, AccountState } from "./account-reducers";
import * as fromAccount from './account-reducers'

export const selectAccountState = createFeatureSelector<AccountState>('account');

export const selectAccount = createSelector(
    selectAccountState,
    fromAccount.selectAll
);

export const isUserInformationLoaded = createSelector(
    selectAccountState,
    state => state.loadedUserInfo
);